import React, { Component } from 'react';
import WebpackerReact from 'webpacker-react';
import ReactHtmlParser from 'react-html-parser';
import { isMobile } from 'react-device-detect';

class NotificationDocument extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
            dropdown: false,
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 


    loadData = () => {
        fetch(`/document_management/get_notifications`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                data: data.data,
                isLoaded: false
            });
        });
    }

    updateState = (notification_id) => {
        fetch(`/document_management/update_state/${notification_id}`, {
            method: 'PATCH', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                data: this.state.data.filter(item => item.id != notification_id)
            })
        });
    }

    updateAll = () => {
        fetch(`/document_management/update_all_notification`, {
            method: 'PATCH', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.loadData();
            this.setState({ dropdown: false })
        });
    }

    render() {
        const styleButtom = {
            color: "#3f6ad8",
            cursor: "pointer"
        }

        return (
            <React.Fragment>
                <div className={`dropdown ${this.state.dropdown ? "show" : ""}`}>
                    {this.state.data.length >= 1 && (
                        <button type="button" className={`p-0 ${isMobile ? "ml-2" : "mr-4"} btn btn-link`} aria-haspopup="true" aria-expanded={this.state.dropdown} onClick={() => this.setState({ dropdown: !this.state.dropdown })}>
                            <span className="icon-wrapper icon-wrapper-alt rounded-circle">
                                <span className="icon-wrapper-bg bg-danger"></span>
                                    <i className={`icon text-danger icon-anim-pulse ${this.state.dropdown ? "fas fa-times" : "fas fa-envelope-open-text"}`}></i>
                                <span className="badge badge-dot badge-dot-sm badge-danger">10</span>
                            </span>
                        </button>
                    )}

                    <div 
                        tabIndex="-1" 
                        role="menu" 
                        aria-hidden="true" 
                        className={`dropdown-menu-xl rm-pointers test-dropdown dropdown-menu-right ${isMobile ? "test-dropdown-movil" : ""}`}
                        style={{ position: "absolute", top: "0px", left: "0px", transform: "translate3d(-358px, 46px, 0px)", display: this.state.dropdown ? "block" : "none", minWidth: "25rem" }}
                    
                    >                    
                        <div className="dropdown-menu-header mb-0">
                            <div className="dropdown-menu-header-inner bg-deep-blue">
                                <div className="menu-header-image opacity-1"></div>
                                <div className="menu-header-content text-dark">
                                    <h5 className="menu-header-title">Notificaciones de documentos</h5>
                                    <h6 className="menu-header-subtitle">Tienes <b>{this.state.data.length}</b> notificación sin leer</h6>
                                </div>
                            </div>
                        </div>

                            <div className="tab-content">
                                <div className="tab-pane active" id="tab-messages-header" role="tabpanel">
                                    <div className="scroll-area-sm">
                                        <div className="scrollbar-container">
                                            <ul className="todo-list-wrapper list-group list-group-flush">
                                                {this.state.data.length >= 1 ? (
                                                    <React.Fragment>
                                                        {this.state.data.map(notification => (
                                                            <li className="list-group-item" key={notification.id}>
                                                                <div className="todo-indicator bg-success"></div>
                                                                <div className="widget-content p-0">
                                                                    <div className="widget-content-wrapper">
                                                                        <div className="widget-content-left flex2">
                                                                            <div className="widget-heading">{ReactHtmlParser(notification.title)}</div>
                                                                            <div className="widget-subheading text-left">
                                                                                {ReactHtmlParser(notification.description)}
                                                                            </div>
                                                                            <a 
                                                                                href={`/document_management/documents/${notification.document.token}`} 
                                                                                className="ml-1" 
                                                                                style={styleButtom}
                                                                                data-turbolinks="true"
                                                                            >
                                                                                Ver documento
                                                                            </a>
                                                                        </div>

                                                                        <div className="widget-content-right">
                                                                            <button className="border-0 btn-transition btn btn-outline-success" onClick={() => this.updateState(notification.id)}>
                                                                                <i className="fa fa-check"></i>
                                                                            </button>
                                                                        </div>
                                                                        
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </React.Fragment>
                                                ) : (
                                                    <div className="no-results pb-0 pt-0">
                                                        <div className="swal2-icon swal2-success swal2-animate-success-icon">
                                                            <div className="swal2-success-circular-line-left" style={{backgroundColor: "rgb(255, 255, 255)"}}></div>
                                                            <span className="swal2-success-line-tip"></span>
                                                            <span className="swal2-success-line-long"></span>
                                                            <div className="swal2-success-ring"></div>
                                                            <div className="swal2-success-fix" style={{backgroundColor: "rgb(255, 255, 255)"}}></div>
                                                            <div className="swal2-success-circular-line-right" style={{backgroundColor: "rgb(255, 255, 255)"}}></div>
                                                        </div>
                                                        <div className="results-subtitle">¡Estás al día con las notificaciones!</div>
                                                    </div>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/*<div className="tab-pane" id="tab-events-header" role="tabpanel">
                                    <div className="scroll-area-sm">
                                        <div className="scrollbar-container">
                                            <ul className="todo-list-wrapper list-group list-group-flush">
                                                {this.state.data.filter(estado => estado.state == true).length >= 1  ? (
                                                    <React.Fragment>
                                                        {this.state.data.filter(estado => estado.state == true).map(notification => (
                                                            <li className="list-group-item" key={notification.id}>
                                                                <div className="todo-indicator bg-success"></div>
                                                                <div className="widget-content p-0">
                                                                    <div className="widget-content-wrapper">
                                                                        <div className="widget-content-left flex2">
                                                                            <div className="widget-heading">{ReactHtmlParser(notification.title)}</div>
                                                                            <div className="widget-subheading text-left">{ReactHtmlParser(notification.description)}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </React.Fragment>
                                                ) : (
                                                    <div className="no-results pb-0 pt-0">
                                                        <div className="swal2-icon swal2-success swal2-animate-success-icon">
                                                            <div className="swal2-success-circular-line-left" style={{backgroundColor: "rgb(255, 255, 255)"}}></div>
                                                            <span className="swal2-success-line-tip"></span>
                                                            <span className="swal2-success-line-long"></span>
                                                            <div className="swal2-success-ring"></div>
                                                            <div className="swal2-success-fix" style={{backgroundColor: "rgb(255, 255, 255)"}}></div>
                                                            <div className="swal2-success-circular-line-right" style={{backgroundColor: "rgb(255, 255, 255)"}}></div>
                                                        </div>
                                                        <div className="results-subtitle">No hay notificaciones leidas!</div>
                                                    </div>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>*/}
                                
                            </div>

                            {true && (
                                <ul className="nav flex-column">
                                    <li className="nav-item-divider nav-item"></li>
                                    <li className="nav-item-btn text-center nav-item">
                                        {this.state.data.length >= 1 && (
                                            <button className="btn-shadow btn-wide btn-pill btn btn-focus btn-sm" onClick={() => this.updateAll()}>Marcar todas como leídas</button>
                                        )}
                                        <button className="btn-shadow btn-wide btn-pill btn btn-danger btn-sm ml-3" onClick={() => this.setState({ dropdown: !this.state.dropdown })}>Cerrar</button>
                                    </li>
                                </ul>
                            )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}


export default NotificationDocument;
WebpackerReact.setup({ NotificationDocument });
